import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { get_settings_saga } from "../../store/actions/my-info";

const myInfoHook = (props) => {
    const dispatch = useDispatch();
    const settings = useSelector(state => state.settings);
    const translate = useSelector(state => state.translate);
    const get_settings = () => {
        if (props.user) {
            dispatch(get_settings_saga(props.user.id));
        }
    }
    useEffect(() => {
        get_settings();
    }, []);
    return { settings, translate };
}
export default myInfoHook;